import { UPDATE_DEVICE_COUNTS } from 'redux/constants/DeviceCounts'

export const fetchDeviceCountsFromDB = (tenantId) => {
  return {
    type: UPDATE_DEVICE_COUNTS,
    tenantId,
  }
}
